import { memo, useEffect, useState } from 'react';
import { Box, Button, CircularProgress } from '@material-ui/core';
import { DownloadIconV2 } from '@setvi/shared/components/sicons';
import { useStyles } from '../styles';

const SETVI_LOGO_URL =
  'https://setvi.azureedge.net/public/Setvi/Logos/PNG/SETVI-Horizontal-Logo-RGB-FullColor_Transparent1x.png';

interface HeaderProps {
  onDownload: () => void;
  downloadEnabled: boolean;
  isDownloading?: boolean;
  isLogoLoading?: boolean;
  logoUrl?: string | null;
  companyName?: string | null;
}

const Header = ({
  onDownload,
  downloadEnabled,
  isDownloading,
  isLogoLoading,
  logoUrl,
  companyName
}: HeaderProps) => {
  const styles = useStyles();
  const [logoFailed, setLogoFailed] = useState(false);

  useEffect(() => setLogoFailed(false), [logoUrl]);

  const useCompanyLogo = Boolean(logoUrl) && !logoFailed;

  return (
    <Box className={styles.header}>
      {!isLogoLoading && (
        <img
          src={useCompanyLogo ? (logoUrl as string) : SETVI_LOGO_URL}
          alt={useCompanyLogo ? companyName || 'Company logo' : 'SETVI'}
          className={styles.logo}
          onError={() => setLogoFailed(true)}
        />
      )}
      <Button
        variant="contained"
        color="primary"
        disabled={!downloadEnabled}
        onClick={onDownload}
        startIcon={
          isDownloading ? (
            <CircularProgress size={16} color="primary" />
          ) : (
            <DownloadIconV2 fill="currentColor" />
          )
        }
        className={styles.downloadButton}>
        Download
      </Button>
    </Box>
  );
};

export default memo(Header);
